import { http } from "Utils/http";
import { STATUSES } from "Utils/constants";
import { store } from 'Store';
import { getRecaptchaToken } from "Components/ReCaptcha";

export const FEEDBACK_URL = "/api/feedback";

const rejectIfPayloadError = (payload) => {
  return payload?.status !== 1 || (payload?.globalErrorMessageList?.length > 0);
};

export const submitFeedback = async (body) => {
  const loginInfo = store.getState().loginInfo;
  const captchaToken = await getRecaptchaToken('feedback_submit').catch(() => null);
  const payload = { ...body, captchaToken, captchaAction: 'feedback_submit' };
  let status = STATUSES.SUCCESS;
  return http
    .post(FEEDBACK_URL, payload, {
      headers: {
        "Authorization": "Bearer " + loginInfo.token
      }
    })
    .then((res) => {
      const payload = res;
      if (payload?.status === -1 && payload?.globalErrorMessageList?.length > 0) {
        return Promise.reject({ status: STATUSES.ERROR, globalErrorMessageList: payload.globalErrorMessageList });
      }
      if (rejectIfPayloadError(payload)) {
        status = STATUSES.ERROR;
        return Promise.resolve({ status, data: payload });
      }
      return Promise.resolve({ status, data: payload });
    })
    .catch((error) => {
      status = STATUSES.ERROR;
      return Promise.reject({ status, data: error });
    });
};
